import React from 'react';
import {
  Card,
  Modal,
  Row,
  Col,
  Button,
  Label,
} from 'reactstrap';
import moment from 'moment';

const ModalErrorLog = (props) => {
  const {
    modalErrorsControl,
    setModalErrorsControl,
  } = props;

  const handleClose = () => {
    setModalErrorsControl({ ...modalErrorsControl, open: false });
  };

  return (
    <Modal isOpen={modalErrorsControl.open} toggle={handleClose}>
      <Card>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12} className="d-flex justify-content-end">
            <Button close onClick={handleClose} />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12} className="d-flex justify-content-center">
            <Label>Erros</Label>
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }}>
          <Col lg={12} className="d-flex justify-content-center">
            {renderErrorsList()}
          </Col>
        </Row>
      </Card>
    </Modal>
  );

  function renderErrorsList() {
    if (modalErrorsControl.errors.length <= 0) {
      return (
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-center">
          <Label>Nenhum resultado encontrado</Label>
        </Row>
      )
    }
    return (
      <>
        {modalErrorsControl.errors.map(e => {
          return (
            <Row key={e.id} style={{ marginBottom: 10 }} className="d-flex justify-content-center">
              <Card body style={{ backgroundColor: '#e8eced', marginBottom: 10 }}>
                <Row style={{ marginBottom: 5 }}>
                  <Col xs="10">
                    {e.errorMessage ? (
                      <>
                        <Label style={{ color: 'black', fontWeight: 'bold' }}>Mensagem: </Label>
                        <Label style={{ color: 'black' }}>{e.errorMessage}</Label>
                      </>
                    ) : null}
                  </Col>
                  <Col xs="2" className="d-flex justify-content-end">
                    <Button color="warning" size="sm">
                      <i className="fa fa-exclamation-triangle" />
                    </Button>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black', fontWeight: 'bold' }}>Data</Label>
                    <Label style={{ color: 'black' }}>{moment(e.date).format()}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black', fontWeight: 'bold' }}>ID Participante</Label>
                    <Label style={{ color: 'black' }}>{e.guestId}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black', fontWeight: 'bold' }}>ID Programacao</Label>
                    <Label style={{ color: 'black' }}>{e.scheduleId}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black', fontWeight: 'bold' }}>Url</Label>
                    <Label style={{ color: 'black' }}>{e.url}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black', fontWeight: 'bold' }}>Detalhes</Label>
                    <Label style={{ color: 'black' }}>{e.data}</Label>
                  </Col>
                </Row>
              </Card>
            </Row>
          )
        })}
      </>
    )
  }
};

export default ModalErrorLog;
